// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".93116ea8bf9c74664aa492246ea4f938195e009e.chunk.bundle.js";
};